// extracted by mini-css-extract-plugin
export default {"iconWithChain":"TokenAvatar_iconWithChain__Xph-n","icon":"TokenAvatar_icon__p2M2h","isNft":"TokenAvatar_isNft__e3dTt","chainLogo":"TokenAvatar_chainLogo__uy+ny"};